import { IOption } from "Dashboard/domain/IOption";
import { useEffect, useState } from "react";
import { partnersService } from "../services/partner.service";

export function usePartnerOptions() {
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    async function getPartners() {
      const response = await partnersService.getPartnersForDropdown();
      const op = response.partners.map((partner) => {
        return {
          label: partner.fullName,
          value: partner.partnerId,
        };
      });
      setOptions(op);
    }

    try {
      getPartners();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return options;
}
